import React, { PureComponent } from 'react';
import ChangeEmail from 'modules/accountManagement/ChangeEmail';
import DataExport from 'modules/accountManagement/DataExport';
import DataImport from 'modules/accountManagement/DataImport';
import DeleteAccount from 'modules/accountManagement/DeleteAccount';
import { Link } from 'react-router-dom';
import strings from 'helper/localization/localization';

export default class AccountManagement extends PureComponent {
  constructor(props) {
    super(props);

    // Properties
    this.api = this.props.api;
    this.user = this.props.user;
    this.updateUser = this.props.updateUser;
    this.logoutUser = this.props.logoutUser;
    this.successMessage = this.props.location.state && this.props.location.state.successMessage;
    this.enteredFromWHT = this.props.enteredFromWHT;
    this.backToProfileLink = this.props.backToProfileLink;
  }

  render() {
    const successAlert = this.successMessage ?
      (
        <div className="alert alert-success alert-dismissible fade show" role="alert">
          {this.successMessage}
          <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">{'\u00D7'}</span>
          </button>
        </div>
      ) : null;

    return (
      <div>
        <ChangeEmail
          api={this.api}
          user={this.user}
          updateUser={this.updateUser}
        />

        <DeleteAccount
          api={this.api}
          updateUser={this.updateUser}
          logoutUser={this.logoutUser}
          enteredFromWHT={this.enteredFromWHT}
          backToProfileLink={this.backToProfileLink}
        />

        <DataExport api={this.api} />

        <DataImport api={this.api} />

        <div className="container">
          { successAlert }
          <div className="row">
            <div className="col">
              <h1 id="account-manage--title">{strings.manageMyAccount}</h1>
            </div>
          </div>

          <div className="card mt-3">
            <ul className="list-group manage-account list-group-flush">
              <li
                className="list-group-item list-group-item-action"
                data-toggle="modal"
                data-target="#dataExportModal"
                id="data-export"
              >
                <h5 className="mb-1">{strings.exportAllMyData}</h5>
                <p>{strings.downloadMyData}</p>
              </li>
              <li
                className="list-group-item list-group-item-action"
                data-toggle="modal"
                data-target="#dataImportModal"
                id="data-import"
              >
                <h5 className="mb-1">{strings.importMyData}</h5>
                <p>{strings.uploadMyData}</p>
              </li>
              <li
                className="list-group-item list-group-item-action"
                data-toggle="modal"
                data-target="#changeEmailModal"
                id="email--change"
              >
                <h5 className="mb-1">{strings.changeMyEmail}</h5>
                <p>{strings.changeEmailAddress}</p>
              </li>
              <li
                className="list-group-item list-group-item-action"
                data-toggle="modal"
                data-target="#deleteAccountModal"
                id="account--delete"
              >
                <h5 className="mb-1">{strings.deleteMyAccount}</h5>
                <p>{strings.discardData}</p>
              </li>
              <Link
                to="/account/consents"
                id="account--consents"
                className="list-group-item list-group-item-action"
              >
                <h5 className="mb-1">{strings.myConsents}</h5>
                <p>{strings.changeConsents}</p>
              </Link>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/accountManagement/AccountManagement.jsx